/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ColumnMetaDataContextFromJSON, ColumnMetaDataContextToJSON, ColumnMetaDateFormatFromJSON, ColumnMetaDateFormatToJSON, ColumnMetaNumberTypeFromJSON, ColumnMetaNumberTypeToJSON, } from './';
export function ColumnMetaFromJSON(json) {
    return ColumnMetaFromJSONTyped(json, false);
}
export function ColumnMetaFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        name: json['name'],
        dataContext: ColumnMetaDataContextFromJSON(json['dataContext']),
        numberType: !exists(json, 'numberType') ? undefined : ColumnMetaNumberTypeFromJSON(json['numberType']),
        dateFormat: !exists(json, 'dateFormat') ? undefined : ColumnMetaDateFormatFromJSON(json['dateFormat']),
        tableTagId: !exists(json, 'tableTagId') ? undefined : json['tableTagId'],
        manualMapping: !exists(json, 'manualMapping') ? undefined : json['manualMapping'],
        detectedTagMap: !exists(json, 'detectedTagMap') ? undefined : json['detectedTagMap'],
        timePointId: !exists(json, 'timePointId') ? undefined : json['timePointId'],
        applyTagsIds: !exists(json, 'applyTagsIds') ? undefined : json['applyTagsIds'],
    };
}
export function ColumnMetaToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        name: value.name,
        dataContext: ColumnMetaDataContextToJSON(value.dataContext),
        numberType: ColumnMetaNumberTypeToJSON(value.numberType),
        dateFormat: ColumnMetaDateFormatToJSON(value.dateFormat),
        tableTagId: value.tableTagId,
        manualMapping: value.manualMapping,
        detectedTagMap: value.detectedTagMap,
        timePointId: value.timePointId,
        applyTagsIds: value.applyTagsIds,
    };
}
